module.exports = __webpack_public_path__ + "static/media/NvphFanpad2.ea7a78a4.webp";